import React from "react";
import { BLOCK_TYPES, BUTTON_RESET } from "../../../../../styles";
import { uuid } from "../../../../../shared/utils";
import { BlockEditor } from "../Block";
import { deleteOlimpiadaBloco } from "../../../../../services/olimpiadaConteudoApi";

export function GuiaEditor({ guia, onChange, showFlash, onBlockDeleted }) {
  return (
    <div>
      <div style={{ display: "grid", gap: 10, marginBottom: 12 }}>
        {(guia.blocos || []).map((bloco) => (
          <BlockEditor
            key={bloco.id}
            bloco={bloco}
            onChange={(novoBloco) =>
              onChange({
                ...guia,
                blocos: guia.blocos.map((item) =>
                  item.id === bloco.id ? novoBloco : item,
                ),
              })
            }
            onRemove={async () => {
              try {
                if (
                  !window.confirm(
                    "Tem certeza que deseja excluir este bloco? Esta ação não pode ser desfeita.",
                  )
                ) {
                  return;
                }
                const isBlocoTemporario = !bloco.id || isNaN(Number(bloco.id));

                if (!isBlocoTemporario) {
                  await deleteOlimpiadaBloco(bloco.id);
                }

                onChange({
                  ...guia,
                  blocos: guia.blocos.filter((item) => item.id !== bloco.id),
                });

                if (onBlockDeleted && !isBlocoTemporario) {
                  onBlockDeleted(bloco.id);
                }

                showFlash(
                  isBlocoTemporario
                    ? "Bloco removido do rascunho."
                    : "Bloco removido com sucesso."
                );
              } catch (err) {
                console.error("Erro ao excluir bloco na API", err);
                showFlash("Erro ao remover o bloco.", "er");
              }
            }}
          />
        ))}
        {!guia.blocos?.length && (
          <div style={{ color: "#94A3B8", fontSize: 13 }}>
            Nenhum bloco nesta guia.
          </div>
        )}
      </div>

      <div
        style={{
          display: "grid",
          gap: 8,
          gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
        }}
      >
        {BLOCK_TYPES.map((item) => (
          <button
            key={item.tipo}
            onClick={() =>
              onChange({
                ...guia,
                blocos: [
                  ...(guia.blocos || []),
                  {
                    id: uuid(),
                    tipo: item.tipo,
                    html: "",
                    arquivos: item.tipo === "anexo" ? [] : undefined,
                  },
                ],
              })
            }
            style={{
              ...BUTTON_RESET,
              textAlign: "left",
              padding: 12,
              borderRadius: 12,
              background: item.fundo,
              border: `1px solid ${item.cor}33`,
              color: item.cor,
            }}
          >
            <div style={{ fontSize: 13, fontWeight: 900 }}>{item.label}</div>
            <div style={{ fontSize: 11, marginTop: 4 }}>{item.descricao}</div>
          </button>
        ))}
      </div>
    </div>
  );
}